// Hợp đồng API của tab «Music Live» (chèn video sang Music Live của BH Media).
import { z } from 'zod';
/**
 * MUSIC LIVE (18/10/2026, chủ dự án gửi CHENVIDEOSANGMUSICLIVE.rar — một trang HTML «BH Media ID Sender»: dán link
 * YouTube → lấy mã video → GET https://live.bhmedia.vn/bhyoutube/webtomusic.php?id=<mã>&ar=CONGTRINH — và bảo «đưa lên
 * web 1 tab riêng biệt»). Trang gốc gọi thẳng từ trình duyệt với `mode: 'no-cors'` nên không bao giờ biết BH Media trả
 * gì; ở đây MÁY CHỦ gọi hộ, ghi lại mã HTTP + thân trả lời, và lưu lịch sử để cả công ty thấy đã chèn video nào, ai gửi.
 */
export const MUSIC_LIVE_ENDPOINT = 'https://live.bhmedia.vn/bhyoutube/webtomusic.php';
/** Mã đối tác (`ar=`) trong trang gốc; Giám đốc đổi được ngay ở tab. */
export const MUSIC_LIVE_DEFAULT_PARTNER = 'CONGTRINH';
export const MUSIC_LIVE_MAX_LINKS = 50;
const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;
/**
 * Mã video từ link YouTube: `watch?v=`, `youtu.be/`, `/live/`, `/shorts/`, `/embed/`, `/v/` (có hay không `https://`,
 * `www.`, `m.`), hoặc dán sẵn mã 11 ký tự. Không nhận ra thì `null`.
 */
export function extractYoutubeVideoId(input) {
    const text = input.trim();
    if (!text)
        return null;
    if (VIDEO_ID.test(text))
        return text;
    // Tách host · đường dẫn · query bằng biểu thức chính quy (gói shared không có lớp URL của trình duyệt).
    const parts = /^(?:https?:\/\/)?(?:(?:www|m)\.)?([^/?#]+)([^?#]*)(?:\?([^#]*))?/i.exec(text);
    if (!parts)
        return null;
    const host = (parts[1] ?? '').toLowerCase();
    const path = parts[2] ?? '';
    const query = parts[3] ?? '';
    const valid = (id) => (id && VIDEO_ID.test(id) ? id : null);
    if (host === 'youtu.be')
        return valid(path.split('/')[1]);
    if (!/(^|\.)youtube(-nocookie)?\.com$/.test(host))
        return null;
    const fromQuery = /(?:^|&)v=([^&]*)/.exec(query);
    if (fromQuery) {
        const id = valid(decodeURIComponent(fromQuery[1] ?? ''));
        if (id)
            return id;
    }
    const fromPath = /^\/(?:live|shorts|embed|v)\/([A-Za-z0-9_-]{11})(?:\/|$)/.exec(path);
    return fromPath ? (fromPath[1] ?? null) : null;
}
export const musicLiveSendRequestSchema = z.object({
    /** Mỗi dòng một link (hoặc mã video); máy chủ bỏ dòng trống, bỏ trùng trong cùng lượt. */
    links: z.array(z.string().trim().max(500)).min(1).max(MUSIC_LIVE_MAX_LINKS),
});
export const musicLiveSettingsSchema = z.object({
    partner: z.string().trim().min(1, 'Chưa nhập mã đối tác').max(60),
});
//# sourceMappingURL=music-live.js.map